import { z } from 'zod';
import { ActivityType } from './activity-type';
import { GameId } from 'src/app/model/game/game-id';

export const ActivityWinDataSchema = z.object({
  type: z.literal(ActivityType.Win),
  gameId: z.nativeEnum(GameId).default(GameId.Solitaire),
  reward: z.string(),
  winnerNick: z.string(),
  loserNick: z.string(),
  winnerUserId: z.string(),
  loserUserId: z.string(),
  winnerScore: z.number().int(),
  loserScore: z.number().int(),
  bounty: z
    .object({
      amount: z.number(),
      jackpot: z.boolean(),
    })
    .optional(),
});
export type ActivityWinData = z.infer<typeof ActivityWinDataSchema>;

export const ActivityDrawDataSchema = z.object({
  type: z.literal(ActivityType.Draw),
  gameId: z.nativeEnum(GameId).default(GameId.Solitaire),
  reward: z.string(),
  firstPlayerNick: z.string(),
  secondPlayerNick: z.string(),
  firstPlayerUserId: z.string(),
  secondPlayerUserId: z.string(),
  score: z.number().int(),
});
export type ActivityDrawData = z.infer<typeof ActivityDrawDataSchema>;

export const ActivityNewPlayerDataSchema = z.object({
  type: z.literal(ActivityType.NewPlayer),
  nick: z.string(),
});
export type ActivityNewPlayerData = z.infer<typeof ActivityNewPlayerDataSchema>;

export const ActivityReferralRewardDataSchema = z.object({
  type: z.literal(ActivityType.ReferralReward),
  nick: z.string(),
  rewardsCount: z.number().int(), // Ensure rewardsCount is an integer
});
export type ActivityReferralRewardData = z.infer<typeof ActivityReferralRewardDataSchema>;

export const ActivityDataSchema = z.union([
  ActivityWinDataSchema,
  ActivityDrawDataSchema,
  ActivityNewPlayerDataSchema,
  ActivityReferralRewardDataSchema,
]);
export type ActivityData = z.infer<typeof ActivityDataSchema>;

export const ActivityMessageDataSchema = z.object({
  activityId: z.string(),
  createdAt: z.number(),
  displayedAt: z.number().optional(),
  data: ActivityDataSchema,
});
export type ActivityMessageData = z.infer<typeof ActivityMessageDataSchema>;
